// extracted by mini-css-extract-plugin
module.exports = {"preloader":"logo-spinner_preloader__1F2FQ","image":"logo-spinner_image__3czUe","loader":"logo-spinner_loader__2hfuo","spin":"logo-spinner_spin__1xlm4"};